import ProdEnergyHeader from "./Header";
import "./index.css";
import ProdMachineContents from "./ProdMachine";
import ProdVehicleContents from "./ProdVehicle";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdEnergyComponents = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="prod-energy-container" id="prod-energy-id">
      <ProdEnergyHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && <ProdMachineContents productId={productId} />}
      {show && <ProdVehicleContents productId={productId} />}
    </div>
  );
};

export default ProdEnergyComponents;
